import React from "react";
import Mensagem from "./Mensagem";
import ObterHistoricoConversa from "../hooks/ObterHistoricoConversa";
import { useTextosInterface } from "../hooks/TextosInterface";
import { perguntaOriginalDe } from "../lib/resumoConversa";
import { usePergunta } from "../contexts/PerguntaContext";

// Depois de tantas respostas marcadas "não resolveu" na conversa, o atendente aparece ao lado
// do "Sim / Não", sem passar pelo "O que faltou?".
const NAO_RESOLVEU_PARA_ATENDENTE = 2;

interface HistoricoConversasProps {
  slugAtual: string;
  conversaAtual: string;
}

const HistoricoConversas: React.FC<HistoricoConversasProps> = ({
  slugAtual,
  conversaAtual,
}) => {
  const historico = ObterHistoricoConversa(slugAtual, conversaAtual);
  const textosInterface = useTextosInterface();
  const { pergunta } = usePergunta();
  const insistiu =
    historico.filter((m) => m.tipo === "assistente" && m.feedback === "nao").length >=
    NAO_RESOLVEU_PARA_ATENDENTE;

  return (
    <div className="historico-conversas">
      {historico.map((mensagem, indice) => (
        <Mensagem
          key={mensagem.id}
          id={mensagem.id}
          texto={mensagem.texto}
          tipo={mensagem.tipo}
          artigos={mensagem.artigos}
          whatsapps={mensagem.whatsapps}
          slugAtual={slugAtual}
          idRespostaGptSak={mensagem.idRespostaGptSak}
          feedback={mensagem.feedback}
          anexoTexto={mensagem.anexoTexto}
          opcoes={mensagem.opcoes}
          artigoUsado={mensagem.artigoUsado}
          precisaHumano={mensagem.precisaHumano || insistiu}
          registro={mensagem.registro}
          origemAtendente={mensagem.precisaHumano ? "sugerido" : "insistencia"}
          fonte={mensagem.fonte}
          artigoUsadoTitulo={mensagem.artigoUsadoTitulo}
          artigoHtml={mensagem.artigoHtml}
          // Enquanto uma nova pergunta está em andamento, nenhuma resposta antiga pergunta "resolveu?".
          ultima={indice === historico.length - 1 && !pergunta}
          perguntaOriginal={perguntaOriginalDe(historico, indice, textosInterface)}
        />
      ))}
    </div>
  );
};

export default HistoricoConversas;
